import "./About.css";
import { FaWhatsapp, FaInstagram, FaFacebook } from "react-icons/fa";
import { useEffect, useState } from "react";

/* ======================
   TESTIMONIAL DATA
====================== */
const reviews = [
  { text: "Haji showed us hidden beaches we would never find alone.", author: "Sarah – UK" },
  { text: "Professional, kind, and extremely knowledgeable guide.", author: "Marc – France" },
  { text: "Best Zanzibar experience ever. Highly recommended!", author: "Daniel – Germany" },
  { text: "Authentic local insight and perfect organization.", author: "Amina – Kenya" },
  { text: "Haji made our honeymoon unforgettable.", author: "Julia – Italy" },
  { text: "Amazing spice tour and Stone Town walk.", author: "Peter – Netherlands" },
  { text: "Very patient and friendly guide. Loved every moment.", author: "Fatima – UAE" },
  { text: "Excellent English and French communication.", author: "Jean – Canada" },
  { text: "Reliable, punctual, and very professional.", author: "Lucas – Brazil" },
  { text: "Great value for money and personalized tours.", author: "Sophie – Switzerland" },
  { text: "Knows Zanzibar like the back of his hand.", author: "Ahmed – Egypt" },
  { text: "Perfect guide for families and kids.", author: "Emma – Australia" },
  { text: "Safe, fun, and informative tours.", author: "Noah – USA" },
  { text: "Local guide with global standards.", author: "Linda – Sweden" },
  { text: "Would book again without hesitation!", author: "Carlos – Spain" }
];

/* ======================
   CAROUSEL COMPONENT
====================== */
function TestimonialsCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % reviews.length);
    }, 5000); // 5 seconds

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="testimonial-carousel">
      <div
        className="testimonial-track"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {reviews.map((review, i) => (
          <div className="testimonial-slide" key={i}>
            <div className="testimonial-card">
              <p>“{review.text}”</p>
              <span>— {review.author} ⭐⭐⭐⭐⭐</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ======================
   ABOUT PAGE
====================== */
export default function About() {
  return (
    <section className="about">
      <div className="about-container">
        {/* IMAGE */}
        <div className="about-image">
          <img src="/images/aboutme.jpg" alt="Haji - Zanzibar Tour Guide" />
        </div>

        {/* TEXT */}
        <div className="about-text">
          <h2>About Haji</h2>

          {/* LANGUAGES */}
          <div className="language-badges">
            <span className="badge">🇬🇧 English</span>
            <span className="badge">🇫🇷 French</span>
            <span className="badge">🇹🇿 Swahili</span>
          </div>

          <p>
            Meet <strong>Haji</strong>, a passionate and experienced tour guide
            born and raised on the breathtaking island of Zanzibar. As a
            certified official guide, he ensures smooth, enjoyable, and authentic
            travel experiences.
          </p>

          <p>
            From pristine beaches and spice farms to the historic alleys of Stone
            Town, Haji takes you beyond the usual tourist routes to discover the
            true soul of Zanzibar.
          </p>

          <p>
            Every tour is crafted with authenticity, deep local insight, and a
            personal touch — turning your journey into a lifelong memory.
          </p>

          {/* CONTACT */}
          <h3>Book Your Adventure</h3>
          <ul className="contact-list">
            <li>📅 South Zanzibar excursions available daily</li>
            <li>
              📞 WhatsApp:
              <a
                href="https://wa.me/255682837935"
                target="_blank"
                rel="noreferrer"
              >
                +255 682 837 935
              </a>
            </li>
            <li>
              📷 Follow us:
              <a
                href="https://wa.me/255682837935"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaWhatsapp size={22} color="#25D366" />
              </a>
              <a
                href="https://facebook.com/savi.juma.79"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaFacebook size={22} color="#1877F2" />
              </a>
              <a
                href="https://instagram.com/savi_guide_francophone_zanzibr"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaInstagram size={22} color="#C13584" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div className="testimonials">
        <h3>What Travelers Say</h3>
        <TestimonialsCarousel />
      </div>
    </section>
  );
}
